var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperatorManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3825 10.3076L23.5159 8.91778C24.2864 8.64405 24.9185 8.07847 25.2759 7.34299C25.6333 6.6075 25.6873 5.76103 25.4263 4.98608C25.1654 4.21113 24.6103 3.56978 23.8808 3.20031C23.1513 2.83084 22.3059 2.76284 21.5267 3.01098L6.76038 7.97486L4.78671 6.00894L1.85334 6.99448C1.6571 7.05954 1.48015 7.17244 1.33845 7.32299C1.19675 7.47353 1.09477 7.65699 1.04171 7.85681C0.988648 8.05663 0.986175 8.26651 1.03451 8.46752C1.08285 8.66854 1.18048 8.85435 1.31859 9.00819L5.28788 13.4515C5.61294 13.8153 6.03752 14.0757 6.50908 14.2006C6.98064 14.3255 7.47848 14.3093 7.94096 14.1542L12.2887 12.6894L11.4078 18.9721",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3915 4.40082L12.7725 1.21944C12.613 1.11 12.4302 1.03904 12.2386 1.01215C12.0469 0.985254 11.8517 1.00315 11.6681 1.06444L9.44519 1.81232C9.24327 1.87962 9.06197 1.99756 8.91861 2.15487C8.77524 2.31218 8.67459 2.50362 8.62627 2.7109C8.57794 2.91818 8.58356 3.13439 8.64258 3.33889C8.7016 3.54338 8.81206 3.72933 8.9634 3.87899L11.4847 6.38611",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3394 17.1526C19.5667 17.1526 20.5616 16.1577 20.5616 14.9304C20.5616 13.7031 19.5667 12.7082 18.3394 12.7082C17.1121 12.7082 16.1172 13.7031 16.1172 14.9304C16.1172 16.1577 17.1121 17.1526 18.3394 17.1526Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8963 20.7082C21.8963 19.7652 21.5217 18.8608 20.8549 18.194C20.1881 17.5272 19.2837 17.1526 18.3407 17.1526C17.3977 17.1526 16.4934 17.5272 15.8266 18.194C15.1598 18.8608 14.7852 19.7652 14.7852 20.7082",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorManagement);
export default __webpack_public_path__ + "static/media/operator-management.2f2e0792bc35db13e3fe7874075e2d9f.svg";
export { ForwardRef as ReactComponent };